/* Fresso blog bundles — Shopify AJAX products + Woodstock cart actions */
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const base = root.endsWith('/') ? root : root + '/';
  const currency = window.Shopify?.currency?.active || 'PLN';
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', {style:'currency',currency}).format(cents / 100); }
    catch { return (cents / 100).toFixed(2) + ' ' + currency; }
  };
  const el = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };

  async function fetchProduct(handle) {
    const response = await fetch(base + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'});
    if (!response.ok) throw new Error('Nie można pobrać produktu: ' + handle);
    return response.json();
  }

  async function initialize(host) {
    if (host.dataset.bundleReady) return;
    host.dataset.bundleReady = 'true';
    host.classList.add('fresso-bundle');
    const title = host.dataset.bundleTitle || 'Polecany zestaw Fresso';
    const handles = [...new Set((host.dataset.bundleProducts || '').split(',').map(x => x.trim()).filter(Boolean))].slice(0, 10);
    host.replaceChildren(el('h3', 'fresso-bundle__heading', title), el('p','fresso-bundle__intro','Wybierz produkty i dodaj je razem do koszyka.'));
    const itemsContainer = el('div','fresso-bundle__items');
    const footer = el('div','fresso-bundle__footer');
    const totalWrap = el('div');
    totalWrap.append(el('span','fresso-bundle__total-caption','Łączna cena'), el('strong','fresso-bundle__total','—'));
    const button = el('button','fresso-bundle__button','Dodaj zestaw do koszyka');
    button.type = 'button'; button.disabled = true;
    footer.append(totalWrap,button);
    const message = el('p','fresso-bundle__message'); message.setAttribute('role','status');
    host.append(itemsContainer,footer,message);
    if (!handles.length) { message.textContent = 'Brak produktów w konfiguracji zestawu.'; return; }
    const results = await Promise.allSettled(handles.map(fetchProduct));
    const entries = [];
    results.forEach((result,index) => {
      if (result.status !== 'fulfilled') { message.textContent = 'Nie udało się pobrać części produktów.'; return; }
      const product = result.value;
      const variant = product.variants?.find(v => v.available);
      if (!variant) return;
      const item = el('div','fresso-bundle__item');
      const check = el('input','fresso-bundle__check');
      check.type='checkbox'; check.checked=true;
      check.setAttribute('aria-label','Dodaj: ' + product.title);
      const img = el('img','fresso-bundle__image');
      img.src = product.featured_image || (product.images && product.images[0]) || '';
      img.alt = product.title; img.loading='lazy';
      const details = el('div','fresso-bundle__details');
      const link = el('a','fresso-bundle__name', product.title);
      link.href = base + 'products/' + encodeURIComponent(handles[index]);
      details.append(link);
      if (variant.title && variant.title !== 'Default Title') details.append(el('span','fresso-bundle__variant', variant.title));
      const price = el('div','fresso-bundle__price',money(Number(variant.price)));
      item.append(check,img,details,price);
      itemsContainer.append(item);
      entries.push({variant,check});
      check.addEventListener('change',updateTotal);
    });
    function selected() { return entries.filter(e => e.check.checked); }
    function updateTotal() {
      const chosen = selected();
      totalWrap.querySelector('.fresso-bundle__total').textContent = money(chosen.reduce((sum,e) => sum + Number(e.variant.price),0));
      button.disabled = !chosen.length;
      button.textContent = `Dodaj ${chosen.length} ${chosen.length === 1 ? 'produkt' : chosen.length < 5 ? 'produkty' : 'produktów'}`;
    }
    updateTotal();
    if (!entries.length) message.textContent='W tym zestawie nie ma obecnie dostępnych produktów.';

    // Woodstock: dodaj raz przez Ajax API, a następnie pobierz świeże sekcje.
    // Ten sam mechanizm został zastosowany w działającej poprawce
    // pojedynczego produktu z bloga (26.10.2026).
    async function refreshWoodstockCart(lastVariantId) {
      const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
      const sectionsUrl = base + 'cart?sections=' + sectionIds.join(',') + '&_=' + Date.now();
      const response = await fetch(sectionsUrl, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Nie można odświeżyć widoku koszyka.');
      const sections = await response.json();
      if (!sections['cart-drawer']) throw new Error('Woodstock nie zwrócił sekcji cart-drawer.');

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) {
        window.location.assign(base + 'cart');
        return;
      }

      // Wcześniej to właśnie pozostawiona klasa is-empty ukrywała produkty.
      cartDrawer.classList.remove('is-empty');
      document.querySelectorAll('cart-drawer-items, .cart-drawer, .cart-drawer__items')
        .forEach(node => node.classList.remove('is-empty'));

      // renderContents to natywna metoda z cart-drawer.js motywu Woodstock.
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({ id: lastVariantId, sections });
      } else {
        // Zapasowa synchronizacja dokładnie tych elementów, które odświeża Woodstock.
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        for (const selector of ['.cart-drawer__items', '.cart-drawer__footer--subtotal']) {
          const current = cartDrawer.querySelector(selector);
          const updated = doc.querySelector(selector);
          if (current && updated) current.innerHTML = updated.innerHTML;
        }
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
        else window.location.assign(base + 'cart');
      }

      if (sections['cart-icon-bubble']) {
        const current = document.getElementById('cart-icon-bubble');
        if (current) {
          const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const updated = doc.getElementById('cart-icon-bubble');
          if (updated) current.innerHTML = updated.innerHTML;
        }
      }
    }

    button.addEventListener('click', async () => {
      const chosen = selected(); if (!chosen.length) return;
      button.disabled = true; button.textContent = 'Dodawanie…'; message.textContent = '';
      let added = false;
      try {
        const response = await fetch(base + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: chosen.map(({variant}) => ({id: variant.id, quantity: 1})) })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Błąd dodawania produktów.');
        added = true;
        await refreshWoodstockCart(chosen[chosen.length - 1].variant.id);
        updateTotal();
      } catch (error) {
        console.error('[Fresso bundle]', error);
        message.textContent = added
          ? 'Produkty dodano, ale nie udało się odświeżyć koszyka. Otwórz koszyk lub odśwież stronę — nie klikaj ponownie Dodaj.'
          : (error.message || 'Wystąpił problem. Spróbuj ponownie.');
        if (!added) updateTotal();
        else { button.textContent = 'Dodano do koszyka'; button.disabled = true; }
      }
    });
  }
  function start() {
    document.querySelectorAll('[data-bundle-products]').forEach(host => initialize(host).catch(error => {
      console.error('[Fresso bundle]',error);
      host.textContent = 'Nie udało się wczytać zestawu produktów.';
    }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);
  else start();
})();
